import { buildPath } from "../../../helpers/string";
import { root } from "./root";

export const settings = {
  path: "settings",
  getLink: () => buildPath([root.path, settings.path]),
  permissions: [],
  profile: {
    path: "profile",
    getLink: () => buildPath([settings.path, settings.profile.path]),
    permissions: [],
  },
};
